<app-loader *ngIf="(savedCalculationState$ | async) === apiStates.pending" view="fixed"></app-loader>

<section class="summary">
  <h2 nxHeadline="subsection-small" class="summary-title nx-font-weight-light">{{ 'summary.title' | translate }}</h2>
  <qbe-panel-component>
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'summary.informationsAboutJourney' + (isAppTravelAgency
            ? 'TravelAgency' : '') | translate }}</h3>
          <qbe-illustration name="fatherAndSonHiking" class="summary-panel-illustration"></qbe-illustration>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div *ngFor="let info of informationsAboutJourney" class="bluebox-element">
              <p nxCopytext="normal" class="bluebox-element-title">
                {{ info.title }}
              </p>
              <div class="bluebox-element-values">
                <div *ngFor="let params of info.value" class="bluebox-element-value">
                  <p nxCopytext="normal" class="font-weight-700">
                    {{ params.header }}
                  </p>
                  <p *ngIf="params.description" nxCopytext="normal">
                    {{ params.description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step2">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
  <qbe-panel-component class="qbe-panel-with-margin">
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'summary.offer' | translate }}</h3>
          <qbe-illustration name="womanWithCocktailAtTheBeach" class="summary-panel-illustration"></qbe-illustration>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div *ngFor="let info of offer" class="bluebox-element">
              <p nxCopytext="normal" class="bluebox-element-title">
                {{ info.title }}
              </p>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <p nxCopytext="normal" class="font-weight-700">
                    {{ info.value }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step3">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
  <qbe-panel-component class="qbe-panel-with-margin">
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'policyholder.yourDetails.'+ (isAppTravelAgency ? 'travel-agency-title' : 'title') | translate }}</h3>
          <qbe-illustration name="manDiving" class="summary-panel-illustration"></qbe-illustration>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div *ngFor="let info of yourDetails" class="bluebox-element">
              <p nxCopytext="normal" class="bluebox-element-title">
                {{ info.title }}
              </p>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <p nxCopytext="normal" class="font-weight-700">
                    {{ info.value }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step4">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
  <qbe-panel-component class="qbe-panel-with-margin">
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'policyholder.insuredPersonsData.title' | translate }}
          </h3>
          <qbe-illustration name="fatherAndChildrenWithSuitcases" class="summary-panel-illustration"></qbe-illustration>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div *ngFor="let insured of insureds; index as i" class="insured-wrapper">
              <p nxCopytext="normal" class="font-weight-700">{{ i + 1 }}{{ 'policyholder.insuredPersonsData.insured' |
                translate }}</p>
              <ul *ngIf="insureds$ | async" nxList="small" class="insured-list">
                <li *ngFor="let coverageName of getPremiumCalculationAddOnNames(i)" nxListIcon="check"
                  class="insured-list-item">
                  {{ coverageName }}
                </li>
                <li *ngFor="let sportName of formsService.getInsuredsSportNames(i)" nxListIcon="check"
                  class="insured-list-item">
                  {{ sportName | translate }}
                </li>
              </ul>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'policyholder.firstName.label' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ insured.firstName }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'policyholder.lastName.label' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ insured.lastName }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'policyholder.dateOfBirth.label' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p *ngIf="insured.dateOfBirth" nxCopytext="normal" class="font-weight-700">
                      {{ insured.dateOfBirth | aztDate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step4">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
  <qbe-panel-component *ngIf="isAppAgent && (!isBackOfficeAgent || isPostingOnAgentBehalf)"
    class="qbe-panel-with-margin">
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'policyholder.splitAgent.title' | translate }}</h3>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div *ngFor="let split of agentCommissionSplits.controls.splits.controls; index as i"
              class="insured-wrapper">
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ (i === 0 ? 'policyholder.splitAgent.agentNumber' : 'policyholder.splitAgent.intermediaryNumber') |
                  translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ split.controls.agentNumber.value }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ (i === 0 ? 'policyholder.splitAgent.yourCommission' : 'policyholder.splitAgent.commision') |
                  translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ split.controls.commissionPercent.value }} %
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step4">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
  <qbe-panel-component *ngIf="(showBackEndSection$ | async) && isAppAgentOrTravelAgency" class="qbe-panel-with-margin">
    <div nxLayout="grid" class="summary-panel">
      <div nxRow rowJustify="between">
        <div nxCol="12,12,6,6,6">
          <h3 nxHeadline="section" class="nx-margin-bottom-l">{{ 'offer.toolbox.title' | translate }}</h3>
        </div>
        <div nxCol="12,12,6,6,6">
          <qbe-bluebox>
            <div class="insured-wrapper">
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'offer.toolbox.premiumPercentDecrease' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ backOfficeSection.controls.premiumPercentDecrease.value || '-' }}
                      {{backOfficeSection.controls.premiumPercentDecrease.value ? '%' : ''}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'offer.toolbox.premiumPercentIncrease' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ backOfficeSection.controls.premiumPercentIncrease.value || '-' }}
                      {{backOfficeSection.controls.premiumPercentIncrease.value ? '%' : ''}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'offer.toolbox.postingOnAgentBehalf' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ backOfficeSection.controls.impersonateAgentNumber.value || '-' }}
                    </p>
                  </div>
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700">
                      {{ backOfficeSection.controls.agentData.value }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="bluebox-element">
                <p nxCopytext="normal" class="bluebox-element-title">
                  {{ 'offer.toolbox.specialContractTerms' | translate }}
                </p>
                <div class="bluebox-element-values">
                  <div class="bluebox-element-value">
                    <p nxCopytext="normal" class="font-weight-700 break-word">
                      {{ backOfficeSection.controls.specialContractTermsText.value || '-' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bluebox-element">
              <div class="bluebox-element-title"></div>
              <div class="bluebox-element-values">
                <div class="bluebox-element-value">
                  <nx-link nxStyle="block">
                    <a [routerLink]="editLinks.step3">
                      <nx-icon name="pen"></nx-icon>
                      {{ 'summary.edit' | translate }}
                    </a>
                  </nx-link>
                </div>
              </div>
            </div>
          </qbe-bluebox>
        </div>
      </div>
    </div>
  </qbe-panel-component>
</section>